import React from 'react';
import { Store } from 'lucide-react';
import { useScreenInit } from '../useScreenInit';
export function Marketplace() {
  useScreenInit();
  return <div className="flex flex-col items-center justify-center min-h-[80vh] p-6 text-center" data-id="element-308">
      <div className="w-20 h-20 bg-brand-secondary/10 rounded-full flex items-center justify-center mb-6" data-id="element-309">
        <Store className="w-10 h-10 text-brand-secondary" data-id="element-310" />
      </div>
      <h1 className="text-2xl font-bold text-text-primary mb-2" data-id="element-311">Marketplace</h1>
      <p className="text-text-secondary max-w-xs" data-id="element-312">
        Buy and sell products within the FortuneBridge community. Coming soon!
      </p>
    </div>;
}